import { getDefaultBlogPosts } from '../database/seedManager.js';

const FALLBACK_IMAGE = '/images/shared-oxygen-linkedin.png';

const seedImageBySlug = getDefaultBlogPosts().reduce((map, post) => {
  if (post.slug && post.imageUrl) {
    map[post.slug.toLowerCase()] = post.imageUrl;
  }
  return map;
}, {});

const LEGACY_IMAGE_REDIRECTS = {
  '/images/blog/ai-for-insurance-agents.jpg': '/images/blog/insurance-agents-governance.svg',
  '/images/blog/agentic-llm-getting-started.jpg': '/images/blog/agentic-llm-authority.svg',
  '/images/blog/ai-master-data-management.jpg': '/images/blog/mdm-reference-layer.svg',
  '/images/blog/mcp-context.jpg': '/images/blog/mcp-context-control-plane.svg',
  '/images/blog/mcp-rag.jpg': '/images/blog/mission-critical-rag-agents.svg',
  '/images/blog/generative-ai-advancements.jpg': '/images/blog/generative-ai-discipline.svg',
  '/images/blog/rag-understanding.jpg': '/images/blog/rag-evidence-discipline.svg',
  '/images/blog/ai-workflow-vs-agents.jpg': '/images/blog/ai-workflow-vs-agents.svg',
};

export const getSeedImageBySlug = slug => {
  if (!slug) return null;
  return seedImageBySlug[String(slug).toLowerCase()] || null;
};

export const getDefaultBlogImageByTitle = title => {
  if (!title) return FALLBACK_IMAGE;

  const lowerTitle = title.toLowerCase();
  if (lowerTitle.includes('agentic llm')) return '/images/blog/agentic-llm-authority.svg';
  if (lowerTitle.includes('insurance')) return '/images/blog/insurance-agents-governance.svg';
  if (lowerTitle.includes('master data') || lowerTitle.includes('mdm')) {
    return '/images/blog/mdm-reference-layer.svg';
  }
  if (lowerTitle.includes('data') && lowerTitle.includes('executable')) {
    return '/images/blog/ai-flight-deck-data-transformation.svg';
  }
  if (lowerTitle.includes('workflow')) return '/images/blog/ai-workflow-vs-agents.svg';
  if (lowerTitle.includes('generative')) return '/images/blog/generative-ai-discipline.svg';
  if (lowerTitle.includes('mission-critical') || lowerTitle.includes('mission critical')) {
    return '/images/blog/mission-critical-rag-agents.svg';
  }
  if (lowerTitle.includes('retrieval') || (lowerTitle.includes('rag') && lowerTitle.includes('evidence'))) {
    return '/images/blog/rag-evidence-discipline.svg';
  }
  if (lowerTitle.includes('mcp') || lowerTitle.includes('context protocol')) {
    return '/images/blog/mcp-context-control-plane.svg';
  }
  if (lowerTitle.includes('trust stack')) return '/images/blog/ai-trust-stack.svg';
  if (lowerTitle.includes('agentic')) return '/images/blog/agentic-ai-command-map.svg';

  return FALLBACK_IMAGE;
};

export const resolveBlogImageUrl = ({ title, slug, imageUrl } = {}) => {
  const seedImage = getSeedImageBySlug(slug);
  if (seedImage) return seedImage;

  if (imageUrl) {
    const normalized = imageUrl.trim();
    if (LEGACY_IMAGE_REDIRECTS[normalized]) {
      return LEGACY_IMAGE_REDIRECTS[normalized];
    }
    if (normalized.startsWith('/images/blog/') || normalized.startsWith('http')) {
      return normalized;
    }
  }

  return getDefaultBlogImageByTitle(title);
};

export const normalizeBlogPost = post => {
  if (!post) return post;

  return {
    ...post,
    imageUrl: resolveBlogImageUrl({
      title: post.title,
      slug: post.slug || post.id,
      imageUrl: post.imageUrl,
    }),
  };
};
